import { render, staticRenderFns } from "./403.vue?vue&type=template&id=c84e29fa&"
import script from "./403.vue?vue&type=script&lang=ts&"
export * from "./403.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports